import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * @param {string} html - The HTML string to sanitize
 * @param {Object} config - Optional DOMPurify configuration
 * @returns {string} - Sanitized HTML string safe for rendering
 */
export const sanitizeHtml = (html, config = {}) => {
    if (!html || typeof html !== 'string') {
        return '';
    }

    // Default configuration - allows common HTML tags used in notifications
    const defaultConfig = {
        ALLOWED_TAGS: [
            'p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'ul', 'ol', 'li', 'a', 'span', 'div', 'blockquote', 'code', 'pre',
            'sub', 'sup', 'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td'
        ],
        ALLOWED_ATTR: [
            'href', 'target', 'rel', 'class', 'id', 'style', 'src', 'alt', 
            'title', 'width', 'height', 'align', 'colspan', 'rowspan'
        ],
        ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
        ALLOW_DATA_ATTR: false,
        SAFE_FOR_TEMPLATES: true,
    };

    const mergedConfig = { ...defaultConfig, ...config };

    return DOMPurify.sanitize(html, mergedConfig);
};

/**
 * Creates a sanitized object for use with dangerouslySetInnerHTML
 * @param {string} html - The HTML string to sanitize
 * @param {Object} config - Optional DOMPurify configuration
 * @returns {Object} - Object with __html property containing sanitized HTML
 */
export const createSanitizedMarkup = (html, config = {}) => {
    return { __html: sanitizeHtml(html, config) };
};

export default sanitizeHtml;
